export default __webpack_public_path__ + "static/media/partners.e3273504.png";